export default __webpack_public_path__ + "static/media/coin-icon.0fc281b9.svg";